import { tsInitVue } from './js-utils'
import EventReimbursementGrid from '../js/vue-components/event-reimbursement-grid.vue'

document.addEventListener('DOMContentLoaded', function () {
  if (document.querySelector('body.events.reimbursement-files')) {
    const eventReimbursementGridEl = document.querySelector('div[data-is="EventReimbursementGrid"]')
    if (eventReimbursementGridEl instanceof HTMLElement) {
      window.eventsReimbursementGrid = tsInitVue(EventReimbursementGrid, eventReimbursementGridEl, {
        listUrl: eventReimbursementGridEl.dataset.listUrl,
        initialFilters: eventReimbursementGridEl.dataset.initialFilters,
      })
    }
  }
})
